import { render, staticRenderFns } from "./Sparande.vue?vue&type=template&id=e75a9d80&"
import script from "./Sparande.vue?vue&type=script&lang=js&"
export * from "./Sparande.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports